import * as actions from "./actionsTypes";

const initialData = {
  loaderCampaigns: false,
  campaigns: null,
  campaignsFail: null,
  saveLoaderCampaigns: false,
  campaignsFormError: null,
  loaderTrainingsCalendar: false,
  trainingsCalendar: null,
  trainingsCalendarFail: null,
  loaderTrainingsEmployeesCalendar: false,
  trainingsEmployeesCalendar: null,
  trainingsEmployeesCalendarFail: null,
};

export default function CampaignsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_CAMPAIGNS:
      return { ...state, loaderCampaigns: action.payload };

    case actions.GET_CAMPAIGNS:
      return { ...state, campaigns: action.payload };

    case actions.CAMPAIGNS_FAIL:
      return { ...state, campaignsFail: action.payload };

    case actions.SAVE_LOADER_CAMPAIGNS:
      return { ...state, saveLoaderCampaigns: action.payload };

    case actions.FORM_CAMPAIGNS_FAIL:
      return { ...state, campaignsFormError: action.payload };

    case actions.LOADER_TRAININGS_CALENDAR:
      return { ...state, loaderTrainingsCalendar: action.payload };

    case actions.GET_TRAININGS_CALENDAR:
      return { ...state, trainingsCalendar: action.payload };

    case actions.TRAININGS_CALENDAR_FAIL:
      return { ...state, trainingsCalendarFail: action.payload };

    case actions.LOADER_TRAININGS_EMPLOYEES_CALENDAR:
      return { ...state, loaderTrainingsEmployeesCalendar: action.payload };

    case actions.GET_TRAININGS_EMPLOYEES_CALENDAR:
      return { ...state, trainingsEmployeesCalendar: action.payload };

    case actions.TRAININGS_EMPLOYEES_CALENDAR_FAIL:
      return { ...state, trainingsEmployeesCalendarFail: action.payload };
      
    default:
      return state;
  }
}
